const getters = {
  gengoInfo: state => state.menu.gengoList, // 元号選択リスト
  gengoYear: state => state.menu.gengoYear, // 令和（最新元号の元年）
}

export default getters
